import axios from "axios";
import { xs_languageCode, systemCode } from "../..";
import { getConfiguration } from '../utils/configuration';


function parseMonitorConfiguration(response){
	try{
		if(response.code == 0){
			const sportList = [];
			const pageList = JSON.parse(response.object).pageList;
			const tournamentList = [];
			const sportListNative = JSON.parse(response.sportRadarList).sps;
			const tournamentLookup = {};
			const sportLookup = {};
			const categoryLookup = {};
			for(let i in sportListNative){
				const sportN = sportListNative[i];
				const categories = [];
				const sport = {
					sportId : sportN.id,
					description : sportN.dsl[xs_languageCode],
					categories
				};
				sportLookup[sport.sportId] = sport;
				for(let j in sportN.cts){
					const categoryN = sportN.cts[j];
					const tournaments = [];
					const category = {
						categoryId : categoryN.id,
						description : categoryN.dsl[xs_languageCode],
						tournaments
					};
					const keyC = [sport.sportId, category.categoryId].join('_');
					categoryLookup[keyC] = category;
					for(let k in categoryN.tns){
						const tournamentN = categoryN.tns[k];
						const tournament = {
							tournamentId : tournamentN.id,
							description : tournamentN.dsl[xs_languageCode]
						};
						tournaments.push(tournament);
						const keyT = [sport.sportId, category.categoryId, tournament.tournamentId].join('_');
						tournamentLookup[keyT] = tournament;
						tournamentList.push({
							description : [sport.description, category.description, tournament.description].join(" - "),
							sportId : sportN.id,
							categoryId : categoryN.id,
							tournamentId : tournamentN.id
						});
					}
					categories.push(category);
				}
				sportList.push(sport);
			}
			
			// filter the page list entities: if something has been closed, I remove it. In this way I will save always something good
			for(let kp in pageList){
				const page = pageList[kp];
				if(page.type === 'LIVE'){
					const spsNew = [];
					if(page.sps){
						for(let ks in page.sps){
						// if is still opened
							const sportId = page.sps[ks];
							if(sportLookup[sportId]){
								spsNew.push(sportId);
							}
						}
					}
					page.sps = spsNew;
				}
				else{
					const tournNew = [];
					for(let kt in page.tls){
						const tourn = page.tls[kt];
						const key = [tourn.sp, tourn.ct, tourn.tn].join("_");
						if(tournamentLookup[key]){
							// if is still opened
							tournNew.push(tourn);
						}
					}
					page.tls = tournNew;
				}
			}
			
			return {
				sportList,
				pageList,
				tournamentLookup,
				sportLookup,
				categoryLookup,
				tournamentList
			};
		}
	}
	catch(e){
		console.error(e);
	}
	
	return null;
}



export async function fetchShopMonitorConfiguration(sessionToken, successCallback, errorCallback) {
    const url = getConfiguration().api['shop.getShopMonitorConfigurationDataFromRetail'];
    const params = {
        systemCode,
        lingua: xs_languageCode,
        hash: '',
        sessionToken: sessionToken
    }
    try{
	    const response = await axios.post(url, null, {params});
	    if (!response || response === '' || !response.data || response.data === "") {
            errorCallback();
        }
        else{
        	successCallback(parseMonitorConfiguration(response.data));
        }
    }
    catch(e){
		console.error(e);
    	errorCallback();
    }
}